/**
 * Page de réinitialisation de mot de passe avec token
 * Accessible via lien email (forgot password ou mustChangePassword)
 */

import { useState, FormEvent, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '@e-store/shared';
import './LoginPage.css';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Token de réinitialisation manquant. Veuillez utiliser le lien reçu par email.');
    }
  }, [token]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    // Validation
    if (password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }

    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (!token) {
      setError('Token de réinitialisation manquant');
      return;
    }

    setIsSubmitting(true);

    const response = await authApi.resetPassword({ token, password });

    if (response.error) {
      setError(response.error);
      setIsSubmitting(false);
      return;
    }

    setSuccess(true);
    setIsSubmitting(false);

    // Redirection vers login après 3 secondes
    setTimeout(() => {
      navigate('/login');
    }, 3000);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>E-Store</h1>
          <h2>Nouveau mot de passe</h2>
        </div>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div
              className="success-message"
              style={{
                background: '#dcfce7',
                color: '#16a34a',
                border: '1px solid #bbf7d0',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              Mot de passe modifié avec succès !
            </div>
            <p style={{ color: '#64748b', marginTop: '16px' }}>
              Redirection vers la page de connexion...
            </p>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}

            {token ? (
              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                  <label htmlFor="password">Nouveau mot de passe</label>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Minimum 8 caractères"
                    required
                    minLength={8}
                    autoComplete="new-password"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirmez votre mot de passe"
                    required
                    minLength={8}
                    autoComplete="new-password"
                  />
                </div>

                <button type="submit" className="btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Modification...' : 'Modifier le mot de passe'}
                </button>
              </form>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <p style={{ color: '#64748b', marginBottom: '20px' }}>
                  Le lien est invalide ou a expiré.
                </p>
                <Link to="/forgot-password" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
                  Demander un nouveau lien
                </Link>
              </div>
            )}
          </>
        )}

        <div className="login-links" style={{ marginTop: '20px' }}>
          <Link to="/login" className="link">
            Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}
